<script>
  import { sliderTitle, sliderDesc, sliderCta } from './../store/stores';
  import { getContext } from 'svelte';
  import PopupContent from './PopupContent.svelte';
  import CloseButton from './CloseButton.svelte';
  const { open } = getContext('simple-modal');

  let innerWidth;
  let timeLapseManager;
  let timeLapseImage;
  let pageContentEl;
  let isModalOpening = false;
  let isModalOpened = false;
  let isModalClosing = false;
  let isModalClosed = false;

  async function loadTimeLapse(mapPinId) {
    const hostname = '//' + location.hostname;
    const endpointPath = '/data/map/GetTimeLapse/?mapPinId=';

    try {
      const response = await fetch(hostname + endpointPath + mapPinId);
      const data = await response.json();
      timeLapseManager = new TimeLapseManager(data.MapPinId);

      let timeLapse = data.TimeLapse;
      // Set slider content
      sliderTitle.set(timeLapse.Title);
      sliderDesc.set(timeLapse.Description);
      sliderCta.set(timeLapse.CtaLink);
      timeLapse.TimeLapseMediaItems.map((t) => {
        if (t.NumberOfImages > 0 && t.WidthPerFrame > 0 && t.Height > 0) {
          timeLapseImage = new TimeLapseImage(t, timeLapseManager);
          timeLapseManager.addTimeLapseImage(timeLapseImage);
        }
      });
      timeLapseManager.startImageLoad();
    } catch (error) {
      console.error(`Request issue ${error}`);
    }
  }

  function setProgress(progress) {
    const pBar = document.getElementsByClassName(
      'time-lapse-progress-download'
    )[0];
    pBar.style.width = progress + '%';
  }

  function TimeLapseManager(mapPinId) {
    this.mapPinId = mapPinId;
    this.totalImages = 0;
    this.totalImagesLoaded = 0;
    this.loadedCount = 0;
    this.tlImages = [];
    // When sequentialImageLoadingis true images are loaded 1 after the other
    // When true the first image is loaded then the rest are loaded in synchronously
    this.sequentialImageLoading = false;
    this.parallelLoads = 2;
    this.imagesLoading = 0;
    this.lastImageShown = 0;
  }

  TimeLapseManager.prototype.startImageLoad = function () {
    this.stepSize = 100 / this.totalImages;
    // Trigger the first image to load
    this.tlImages[0].loadImage();
  };

  TimeLapseManager.prototype.spriteDiv = function () {
    return document.getElementsByClassName('time-lapse-sprite')[0];
  };

  TimeLapseManager.prototype.imagesLoaded = function (timeLapseImage) {
    this.imagesLoading = this.imagesLoading - 1;
    // console.info(
    //   'imageLoaded ' +
    //     timeLapseImage.alt +
    //     ' this.imagesLoading=' +
    //     this.imagesLoading
    // );

    let count = timeLapseImage.numberOfImages;
    let timeLapseManager = this;
    this.totalImagesLoaded += count;

    let processing = true;
    timeLapseManager.loadedCount = 0;
    // Loop through in order
    this.tlImages.forEach((tiImage) => {
      if (!tiImage.loaded) {
        processing = false;
        if (
          !this.sequentialImageLoading &&
          this.imagesLoading < this.parallelLoads
        ) {
          tiImage.loadImage();
        } else if (
          this.sequentialImageLoading &&
          tiImage.tlId == timeLapseImage.tlId + 1
        ) {
          tiImage.loadImage();
        }
      }
      if (processing) {
        timeLapseManager.loadedCount += tiImage.numberOfImages;
      }
    });
    let percentage = Math.floor(timeLapseManager.loadedCount * this.stepSize);
    if (percentage > 100) percentage = 100;
    setProgress(percentage);

    if (timeLapseManager.loadedCount > 0 && !this.showingFirstImage) {
      const slider = document.getElementsByClassName('time-lapse-slider')[0];
      slider.step = Math.floor(100 / this.totalImages);
      this.showingFirstImage = true;
      this.showImage(1);
      slider.oninput = function () {
        let imageNumber = Math.floor(
          (timeLapseManager.totalImages / 100) * this.value
        );

        let stepValue = timeLapseManager.totalImages / 100;
        imageNumber = Math.floor(stepValue * this.value);
        if (imageNumber > timeLapseManager.loadedCount) {
          imageNumber = timeLapseManager.loadedCount;
          this.value = imageNumber / stepValue;
        }
        timeLapseManager.showImage(imageNumber);
      };
      slider.onchange = function () {
        let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if (!isIE11) return;

        let stepValue = timeLapseManager.totalImages / 100;
        let imageNumber = Math.floor(stepValue * this.value);
        if (imageNumber > timeLapseManager.loadedCount) {
          imageNumber = timeLapseManager.loadedCount;
          this.value = imageNumber / stepValue;
        }
        timeLapseManager.showImage(imageNumber);
      };
    }
  };

  TimeLapseManager.prototype.showImage = function (imageNumber) {
    if (imageNumber <= 0) return;
    this.lastImageShown = imageNumber;
    this.tlImages.forEach((tiImage) => {
      if (
        imageNumber >= tiImage.startImage &&
        imageNumber <= tiImage.endImage
      ) {
        tiImage.showImage(imageNumber);
        return;
      }
    });
  };

  TimeLapseManager.prototype.refresh = function () {
    this.showImage(this.lastImageShown);
  };

  TimeLapseManager.prototype.addTimeLapseImage = function (timeLapseImage) {
    this.tlImages.push(timeLapseImage);
  };

  function TimeLapseImage(jsonObject, timeLapseManager) {
    this.tlId = timeLapseManager.tlImages.length + 1;
    this.timeLapseManager = timeLapseManager;
    this.loading = false;
    this.loaded = false;
    this.jsonObject = jsonObject;
    this.mediaUrl = jsonObject.MediaUrl;
    this.numberOfImages = jsonObject.NumberOfImages;
    this.widthPerFrame = jsonObject.WidthPerFrame;
    this.height = jsonObject.Height;
    this.alt = jsonObject.Alt;

    this.startImage = timeLapseManager.totalImages + 1;
    this.endImage = this.startImage + this.numberOfImages - 1;

    timeLapseManager.totalImages += this.numberOfImages;
    let timeLapseImage = this;
    this.img = new Image();
    this.img.onload = function () {
      timeLapseImage.imageLoaded();
    };
  }

  TimeLapseImage.prototype.loadImage = function () {
    if (this.loading) return;
    this.loading = true;
    this.timeLapseManager.imagesLoading++;
    this.img.src = this.mediaUrl;
    // console.info(
    //   'loadImage=' +
    //     this.alt +
    //     ' this.timeLapseManager.imagesLoading=' +
    //     this.timeLapseManager.imagesLoading
    // );
  };

  TimeLapseImage.prototype.imageLoaded = function () {
    this.loaded = true;
    this.timeLapseManager.imagesLoaded(this);
  };

  TimeLapseImage.prototype.showImage = function (imageNumber) {
    let localImageNumber = imageNumber - this.startImage;
    if (localImageNumber < 0 || localImageNumber >= this.endImage) return;

    let sliderSprite = this.timeLapseManager.spriteDiv();
    let ratio = this.widthPerFrame / this.height;
    let computedStyle = getComputedStyle(sliderSprite);
    let divWidth = parseInt(computedStyle.width, 0);
    let newHeight = divWidth / ratio;
    sliderSprite.style.backgroundImage = 'url(' + this.img.src + ')';
    sliderSprite.style.height = `${newHeight}px`;
    let offsetX = localImageNumber * divWidth * -1;
    sliderSprite.style.backgroundSize = 'auto 100%';
    sliderSprite.style.backgroundPosition = offsetX + 'px 0px';
  };

  // Resize slider image on window resize
  $: if (
    innerWidth &&
    isModalOpened &&
    timeLapseManager instanceof TimeLapseManager
  ) {
    timeLapseManager.refresh();
  }

  function togglePageContentPosition(position) {
    const pageContentEl = document.getElementById('content');
    if (!pageContentEl) {
      return;
    }
    pageContentEl.classList.toggle(position);
  }

  /**
   * Gateway on click
   */
  const showPopup = (event) => {
    const targetMapPinId = event.detail.mapPinId;
    open(
      PopupContent,
      {},
      {
        closeButton: CloseButton,
        // This window container style
        // The max-width & width it is to set the responsive
        // width size of the time-lapse
        styleWindow: {
          maxWidth: '768px',
          width: '100%',
          borderRadius: '0',
        },
        styleContent: {
          padding: '16px',
        },
      },
      {
        onOpen: () => {
          isModalOpening = true;
          loadTimeLapse(targetMapPinId);
          togglePageContentPosition('position-static');
        },
        onOpened: () => {
          isModalOpening = false;
          isModalOpened = true;
        },
        onClose: () => {
          isModalOpened = false;
          isModalClosing = true;
          togglePageContentPosition('position-static');
        },
        onClosed: () => {
          isModalClosing = false;
          isModalClosed = true;
          setTimeout(() => {
            isModalClosed = false;
          }, 1000);
        },
      }
    );
  };
</script>

<svelte:window bind:innerWidth on:click-gateway={showPopup} />
